// Shared with Export > Medical Certificate (sleep study attendance).
export const getCHGMedicalCertTemplate = (order = "") => ({
  CHG03: "CHG3_WorkLeave.docx",
  CHG11: "CHG11_WorkLeave.docx",
  CHG304: "CHG304_WorkLeave.docx",
  CHG09: "CHG9_WorkLeave.docx",
}[String(order).trim().split("-")[0].toUpperCase()] || "CHG_WorkLeave.docx");

export const getCHGStudyDates = (value) => {
  const studyDate = new Date(`${String(value || "").slice(0, 10)}T12:00:00`);
  if (Number.isNaN(studyDate.getTime())) throw new Error("Select a valid sleep study date.");
  const nextDate = new Date(studyDate);
  nextDate.setDate(nextDate.getDate() + 1);
  const thaiDate = (date) => `วันที่ ${date.toLocaleDateString("th-TH", { day: "numeric", month: "long", year: "numeric" })}`;
  return {
    studyDateThai: thaiDate(studyDate),
    startTimeText: "เวลา 18.00 น.",
    endTimeText: `ถึง ${thaiDate(nextDate)} เวลา 06.00 น.`,
  };
};

// Append only to the rendered remarks paragraph, preserving the template's runs.
export const appendCHGStudyHours = (zip, studyDate) => {
  const { startTimeText, endTimeText } = getCHGStudyDates(studyDate);
  const entry = zip.file("word/document.xml");
  const xml = new DOMParser().parseFromString(entry.asText(), "application/xml");
  const wordNamespace = "http://schemas.openxmlformats.org/wordprocessingml/2006/main";
  const paragraphs = Array.from(xml.getElementsByTagNameNS(wordNamespace, "p"));
  const remarks = paragraphs.find((paragraph) => paragraph.textContent.includes("หมายเหตุ"));
  if (!remarks) throw new Error("The CHG certificate template is missing its remarks paragraph.");
  const texts = Array.from(remarks.getElementsByTagNameNS(wordNamespace, "t"));
  const lastText = texts.filter((text) => text.textContent.trim()).pop();
  lastText.textContent = `${lastText.textContent.trimEnd()} ${startTimeText}`;
  lastText.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
  // Reuse the remarks tab stop so the second line starts at the same column.
  const continuation = lastText.parentNode.cloneNode(false);
  const runProperties = lastText.parentNode.getElementsByTagNameNS(wordNamespace, "rPr")[0];
  if (runProperties) continuation.appendChild(runProperties.cloneNode(true));
  const lineStart = xml.createElementNS(wordNamespace, "w:r");
  lineStart.appendChild(xml.createElementNS(wordNamespace, "w:br"));
  lineStart.appendChild(xml.createElementNS(wordNamespace, "w:tab"));
  remarks.appendChild(lineStart);
  const endText = xml.createElementNS(wordNamespace, "w:t");
  endText.textContent = endTimeText;
  continuation.appendChild(endText);
  remarks.appendChild(continuation);
  zip.file("word/document.xml", xml.documentElement.outerHTML);
  return zip;
};
